function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2-2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M23.279 21.029h-5.4v2h5.4a1.582 1.582 0 010 3.164H15.69v-2.152L6.96 27.2l8.73 3.154v-2.161h7.589a3.582 3.582 0 000-7.164zM24.912 3.142v3.266l-1.313 1.138V4.303l-1.75 1.547v12.194l4.288-3.793V2.058l-1.225 1.084zM5.329 5.282h16.154l1.523-1.319-15.972-.157-1.705 1.476zM25.678 1.65H9.524L8.311 2.7h16.154l1.213-1.05z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M17.233 14.991a.718.718 0 00-.7-.186l-.031.008a.719.719 0 00-.509.509l-.008.031a.718.718 0 00.186.695l.023.022a.718.718 0 00.694.187l.032-.009a.717.717 0 00.508-.508l.009-.032a.718.718 0 00-.187-.694z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M5.139 5.85v12.5h16.142V5.85zm11.923 10.973a1.338 1.338 0 01-1.638-.946 1.3 1.3 0 01-.043-.293l-1.239-1.239-2.094-2.093a2.919 2.919 0 01-.538.165 2.907 2.907 0 01-2.61-.779 2.836 2.836 0 01-.843-2.02 2.878 2.878 0 01.06-.584 2.841 2.841 0 01.173-.543l.944.943.943.944 1.03-.421.421-1.03-.95-.95-.95-.949a2.936 2.936 0 01.58-.2 2.894 2.894 0 012.663.767 2.829 2.829 0 01.771 2.654 2.908 2.908 0 01-.205.584l2.076 2.076 1.287 1.297a1.338 1.338 0 01.158 2.617z"
}))));

var SvgReturnmin = function SvgReturnmin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReturnmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Return.min.dcab7712.svg";
export { ForwardRef as ReactComponent };